import SortOrder from '~/client/src/shared/enums/SortOrder'
import type {
  FieldSchema,
  ListQuery,
  ListQueryPatch,
  ListSchema,
} from '~/client/src/shared/lists/core'

export function isListFieldSortEligible<T>(
  field: FieldSchema<T>,
  activeGroupKey: string | undefined,
): boolean {
  return !!field.sortable || field.key === activeGroupKey
}

export function normalizeGroupingTransition<T>(
  query: ListQuery,
  groupBy: readonly string[],
  schema: ListSchema<T>,
): ListQueryPatch {
  const sortedField = schema.fields.find(field => field.key === query.sortKey)
  const leavingGroupedOnlySort =
    query.sortKey === query.groupBy[0] &&
    groupBy[0] !== query.groupBy[0] &&
    !sortedField?.sortable

  return leavingGroupedOnlySort
    ? { groupBy, sortKey: null, sortOrder: SortOrder.DEFAULT }
    : { groupBy }
}
